module.exports = __webpack_public_path__ + "static/mz-72474189194f5f05dd0c15fb227bb763.png";